import type { ActivityModule } from '../../core/activity';
import { mountOrderingSentences } from './ui';
import levelsData from './levels.json';

export const orderingSentences: ActivityModule = {
  id: 'ordering_sentences',
  title: 'Montar a frase',
  description: 'Coloque as palavras na ordem certa e monte a frase. Clique na próxima palavra.',
  ageMin: 6,
  ageMax: 10,
  difficulty: 3,
  iconPath: 'assets/ensinosocial/ordering_sentences/icon.svg',
  category: 'linguagem',
  totalLevels: levelsData.levels.length,
  mount: mountOrderingSentences,
};
